import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Answer } from '../Review/utils';
import { Report } from 'shared/components/WelcomeBack/utils';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { faSave, faXmark } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { useClient } from 'shared/apollo';
import { updateAnswer } from '../../../NPOFeedback/MakeEdits/api';
import { useGraphQLRequest } from 'shared/auth/hooks/useApiRequest';

interface EditAnswerModalProps {
  index: number;
  report: Report;
  programName: string;
  selectedAnswer: Answer;
  answers: Answer[];
  setAnswers: React.Dispatch<React.SetStateAction<Answer[]>>;
  isReportPassed: boolean;
  handleClose: () => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACERS.extraTiny};
  textarea {
    flex: 1;
  }
  .buttons-wrapper {
    display: flex;
    flex-direction: column;
  }
`;

const EditAnswerModal: React.FC<EditAnswerModalProps> = ({
  index,
  report,
  programName,
  selectedAnswer,
  isReportPassed,
  setAnswers,
  handleClose,
}) => {
  const client = useClient();
  const [requestState, makeRequest] = useGraphQLRequest<unknown>();
  const [text, setText] = useState<string>(selectedAnswer.text || '');

  const handleSubmit = useCallback(() => {
    const request = updateAnswer(client!, {
      reportId: report.dbId,
      questionId: selectedAnswer.questionId,
      answerId: selectedAnswer.dbId,
      ignoreClearData: true,
      answer: text,
    });
    makeRequest(request);
    request.then(r => {
      if (
        r.errors ||
        !r.data ||
        (!r.data.updateNpoAnswer.success && !r.data.newNpoAnswer.success)
      )
        return;
      setAnswers(s => {
        const newState = [...s];
        newState[index].text = text;
        return newState;
      });
      handleClose();
    });
  }, [index, report, selectedAnswer, text, setAnswers]);

  return (
    <StyledDiv>
      <TrueImpactTextfield
        placeholder="Type your answer here"
        value={text}
        isTextarea={true}
        onChange={setText}
        onEnterPress={handleSubmit}
      />
      <div className="buttons-wrapper">
        <TrueImpactIconButton
          label="Save"
          icon={faSave}
          onClick={handleSubmit}
        />
        <TrueImpactIconButton
          label="Close"
          icon={faXmark}
          onClick={handleClose}
        />
      </div>
    </StyledDiv>
  );
};

export default EditAnswerModal;
